export default {
      id: "create-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#create-usage",
      toString: function () {
        return this.url;
      }
    }